import dayjs from "dayjs";

import { useEffect, useState } from "react";

import Diversity3Icon from "@mui/icons-material/Diversity3";
import {
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import { getUserRefereeMap } from "@/api/account";
import { siteName } from "@/constants/config";
import { PRO_REFERRAL_BONUS, REFEREE_BONUS } from "@/constants/config";
import { useGlobalStoreContext } from "@/context/globalStoreContext";

const Referral = () => {
  const store = useGlobalStoreContext();

  const [list, setList] = useState([]);

  useEffect(() => {
    getUserRefereeMap().then((res) => {
      setList(res.data ?? []);
    });
  }, []);

  const renderReferral = () => {
    // if (!store.influencer) {
    //   return null;
    // }

    return (
      <div>
        <div className="flex items-center space-x-[10px]">
          <Diversity3Icon />
          <Typography variant="h4">Referral</Typography>
        </div>
        <Typography>
          Since our launch, we’ve received hundreds of heartfelt thank-you letters for the thousands
          of hours users have saved with AwardTool. Praised by many as the absolute best award
          search tool, countless users have shared their excitement, introducing us to their friends
          far and wide. Now, we’re turning up the excitement with our referral program, making it
          even more rewarding for you to spread the word. The game plan is simple:
          {/* {"Thank you for becoming an " +
            siteName +
            " user! Our latest referral program allows you to receive"}{" "}
          <Typog</Typography>raphy className="inline underline">{"a credit of " + siteName + " PRO"}</Typography>{" "}
          by simply inviting a friend to join using your unique referral link. */}
        </Typography>

        <Typography className="!mt-[15px] text-center">
          <Typography className="!mt-[0px] text-center">For Everyone</Typography>
          Every user(PRO or free) you refer, both you and your referee earn ${REFEREE_BONUS} USD, up
          to $12 USD
          {/* ( or one month of{" "}
          <Typography className="inline !font-semibold" color="primary">
            PRO
          </Typography>{" "}
          membership). */}
        </Typography>
        <Typography className="!mt-[10px] text-center">
          For{" "}
          <Typography className="inline !font-semibold" color="primary">
            PRO
          </Typography>{" "}
          User Only
        </Typography>
        <Typography className="!mt-[0px] text-center">
          On top of the bonuses earned from free user referral, you’ll receive an additional $
          {PRO_REFERRAL_BONUS} USD for every referral that upgrades to{" "}
          <Typography className="inline !font-semibold" color="primary">
            PRO
          </Typography>
          , totaling ${PRO_REFERRAL_BONUS + REFEREE_BONUS} per{" "}
          <Typography className="inline !font-semibold" color="primary">
            PRO
          </Typography>{" "}
          sign-up. Plus, there’s no cap on how much you can earn from PRO user signup!{" "}
        </Typography>

        {/* <Typography>
            - Every free user you referred can earn you ${FREE_REFERRAL_BONUS} credit.
          </Typography>
          <Typography className="!mb-[20px]">
            - The free user you referred can also earn ${REFEREE_BONUS} credit with your link.
          </Typography> */}
        {/* <Typography variant="body2" className="!mt-[15px]">
          There's no restriction on how much credit or how many free months you can accumulate; the
          credit will be automatically added to your account each time someone registers through
          your link.
        </Typography> */}
        <Typography variant="h5" className="!mt-[35px]">
          Referral link
        </Typography>
        <div className="flex items-center justify-center">
          <Typography component={Link} className="items-center justify-center" variant="h6">
            https://awardtool.com/r/{store.referral_code}
          </Typography>
        </div>
        <Typography variant="h5" className="!mt-[35px]">
          Referral Credit
        </Typography>
        <Typography>
          The referral credit will be automatically applied to your future charges on AwardTool.com
          before your credit card is charged.
        </Typography>
        <div className="flex items-center justify-center mt-[10px]">
          <Typography className="items-center justify-center" variant="body1">
            Pro user referred: {store.referral?.pro_referee_count || 0}
          </Typography>
        </div>
        <div className="flex items-center justify-center">
          <Typography className="items-center justify-center" variant="body1">
            Free user referred: {store.referral?.regular_referee_count || 0}
          </Typography>
        </div>
        <div className="flex items-center justify-center">
          <Typography className="items-center justify-center" variant="body1">
            Total Credit: ${store.referral?.balance / 100 || 0}
          </Typography>
        </div>
      </div>
    );
  };

  return (
    <div>
      {renderReferral()}

      <div className="mb-[10px] mt-[35px]">
        <Typography variant="h5" className="!mt-[35px]">
          Your Referrals
        </Typography>
      </div>

      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Referral ID</TableCell>
              <TableCell align="center">Register Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              ".MuiTableCell-root": { paddingY: "10px" },
            }}
          >
            {list.map((row, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row" align="center">
                  {row.user_id}
                </TableCell>
                <TableCell component="th" scope="row" align="center">
                  {dayjs(row.created_at * 1000).format("YYYY-MM-DD HH:mm:ss")}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="h5" className="!mt-[35px]">
        Referral Program Terms
      </Typography>
      <Typography>
        {"The " +
          siteName +
          " Referral Program is an indefinite promotional offer managed by " +
          siteName +
          ". We retain the authority to conclude or modify the conditions of this promotion at our discretion. Credits will be added to your " +
          siteName +
          " account."}
        <Typography>
          Please refer to the{" "}
          <Typography component={Link} href="/guides/referral" className="inline">
            complete terms
          </Typography>{" "}
          term for more details.
        </Typography>
      </Typography>
    </div>
  );
};

export default Referral;
